import axios from 'axios';

interface FeedbackData {
  stayRating: number;
  stayFeedback: string;
  improvementFeedback: string;
}

export async function submitFeedback(data: FeedbackData): Promise<void> {
  try {
    await axios.post('https://frappe.kry.bz/api/method/bmapp.utils.api.post_feedback', data);
  } catch (error) {
    console.error('Error submitting feedback:', error);
    
    // Always throw maintenance message on any error
    throw new Error('Unser System befindet sich gerade in der Wartung, bitte später nochmal versuchen');
  }
}